import * as C from 'io-ts/Codec';
import * as D from 'io-ts/Decoder';
import * as E from 'io-ts/Encoder';
import { XlsxValue } from 'src/modules/common/types/XlsxValue';

const DECODER: D.Decoder<unknown, XlsxValue> = D.nullable(D.union(D.string, D.number));
const ENCODER: E.Encoder<XlsxValue, XlsxValue> = E.id();

export const XLSX_VALUE = C.make(DECODER, ENCODER);
